import { MARQUEE_ITEMS } from "@/data/content";

const Strip = ({ hidden }) => (
  <div aria-hidden={hidden} className="flex shrink-0 items-center">
    {MARQUEE_ITEMS.map((item, i) => (
      <span key={`${item}-${i}`} className="flex items-center">
        <span className="whitespace-nowrap px-8 font-serif text-2xl italic text-sand/50 sm:text-3xl">
          {item}
        </span>
        <span className="inline-block size-1.5 rotate-45 bg-terra/60" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div className="marquee-hover overflow-hidden border-y border-sand/10 bg-roast py-6">
    <div className="animate-marquee flex w-max">
      <Strip hidden={false} />
      <Strip hidden={true} />
    </div>
  </div>
);
